import { route } from '@md/routing'
import { accessPermission } from '@md/users/permissions'

const List = () => import('./views/List')

const ROUTE_NAME = 'profile:wish:'

const p = name => ROUTE_NAME + name

const LIST = p('list')

export function createRoutes(options) {
  return [
    route('list/', List, LIST, {
      meta: accessPermission(['ADS:ADS:VIEW_WISH'], options),
    }),
    { path: '*', redirect: { name: LIST } },
  ]
}
